import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/site/Layout';
import Home from '@/pages/Home';
import Services from '@/pages/Services';
import Work from '@/pages/Work';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import WebsiteDevelopment from '@/pages/services/WebsiteDevelopment';
import WebAppDevelopment from '@/pages/services/WebAppDevelopment';
import MobileAppDevelopment from '@/pages/services/MobileAppDevelopment';
import CustomerSolutionsDevelopment from '@/pages/services/CustomerSolutionsDevelopment';
import EcommerceWebsiteDevelopment from '@/pages/services/EcommerceWebsiteDevelopment';
import AISolutions from '@/pages/services/AISolutions';
import City from '@/pages/City';
import Pricing from '@/pages/Pricing';
import Legal from '@/pages/Legal';
import Landing from '@/pages/Landing';
import WorkDetail from '@/pages/WorkDetail';
import { WORK } from '@/data/work';
import { CITIES } from '@/data/cities';
import { LANDINGS } from '@/data/landings';
import '@/App.css';

function NotFound() {
  return (
    <section className="relative overflow-hidden min-h-[78vh] flex items-center">
      <div aria-hidden className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-[12vw] -top-[18vw] h-[70vw] w-[70vw] max-h-[1000px] max-w-[1000px] rounded-full blur-[20px]"
        style={{ background: 'radial-gradient(circle at 40% 45%, rgba(108,92,231,.3), rgba(75,159,255,.1) 40%, transparent 68%)' }}
      />
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-24 md:py-32">
        <div className="nd-mono">Error · 404</div>
        <div
          aria-hidden
          className="mt-6 font-display font-semibold text-[clamp(120px,26vw,420px)] leading-[0.8] tracking-[-0.07em]"
        >
          4<span className="nd-accent">0</span>4
        </div>
        <div className="mt-10 md:mt-14 pt-8 border-t border-white/[0.08] grid grid-cols-1 md:grid-cols-[1fr_auto] gap-8 items-end">
          <div>
            <h1 className="font-display font-semibold text-[clamp(32px,3.6vw,56px)] leading-none tracking-[-0.04em]">Lost in the file.</h1>
            <p className="mt-4 text-lg text-ink-muted">This page doesn’t exist (or isn’t built yet).</p>
          </div>
          <a href="/" className="nd-btn nd-btn--ghost nd-btn--noicon justify-self-start">
            <span>← Back to home</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/website-development" element={<WebsiteDevelopment />} />
          <Route path="/services/web-app-development" element={<WebAppDevelopment />} />
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopment />} />
          <Route path="/services/custom-software-development" element={<CustomerSolutionsDevelopment />} />
          <Route path="/services/ecommerce-website-development" element={<EcommerceWebsiteDevelopment />} />
          <Route path="/services/ai-solutions" element={<AISolutions />} />
          <Route path="/work" element={<Work />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/website-development-cost" element={<Pricing />} />
          <Route path="/policy" element={<Legal doc="policy" />} />
          <Route path="/tos" element={<Legal doc="tos" />} />
          {CITIES.map((c) => (
            <Route key={c.slug} path={c.path} element={<City slug={c.slug} />} />
          ))}
          {WORK.map((w) => (
            <Route key={w.slug} path={`/work/${w.slug}`} element={<WorkDetail slug={w.slug} />} />
          ))}
          {LANDINGS.map((l) => (
            <Route key={l.slug} path={l.path} element={<Landing slug={l.slug} />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
